import React from 'react'
import styled from 'styled-components'
import { media } from 'utils/media'
import { Link } from 'lib/Link'
import { Text } from 'lib/Text'
import { useCurrentBrand } from 'modules/brands/show/context/CurrentBrandProvider'
import { InlineReviewForm } from './InlineReviewForm'

const Container = styled.div`
  align-items: center;
  align-self: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 32px 0;
  padding: 40px;
  ${media.tabletDown} {
    margin: 0;
    padding: 64px 32px;
  }
`

const BrowseDirectoryLink = styled(Link)`
  display: inline-block;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid var(--black-20);
  padding: 8px 16px;
  border-radius: 3px;
  margin-top: 16px;

  &:hover {
    background: black;
    color: white;
    border-color: black;
    border-bottom-width: 1px;
  }
`

export const NoReviewsByUser = ({ isOwn }: { isOwn: boolean }) => (
  <Container>
    <Text weight="bold" color="black-80" as="h3" margin="1x" size="s">
      No reviews written
    </Text>
    <Text color="black-80" as="p" margin="2x" size="ps">
      {isOwn
        ? `You haven’t written any reviews yet. Once you do, you’ll be able to see all of your reviews here. Browse the directory to find brands that you’ve
      tested and would like to review.`
        : `This user hasn’t written any reviews yet. Once they do, you’ll be able to see all of their reviews here.`}
    </Text>
    {isOwn && <BrowseDirectoryLink href="/brands">Browse the Directory</BrowseDirectoryLink>}
  </Container>
)

export const NoReviewsForBrand = () => {
  const { brand } = useCurrentBrand()

  return (
    <>
      <InlineReviewForm brand={brand} />
      <Container>
        <Text color="black-40" as="h3" size="ps">
          {brand.title} is new to Thingtesting!
        </Text>
      </Container>
    </>
  )
}
